import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const GuestRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-base-200">
                <span className="loading loading-spinner loading-lg text-primary"></span>
            </div>
        );
    }

    if (user) {
        // If user is logged in, redirect to dashboard or waitlist based on status
        if (user.status === 'PENDING_APPROVAL') {
            return <Navigate to="/waitlist" replace />;
        }
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default GuestRoute;
